import { calculateNutritionalValues } from 'lib/nutrition';
import { Variant } from 'lib/product';
import { useMemo } from 'react';
import ProductNutrient from '../ProductNutrient';

interface NormalProductNutritionProps {
  productVariant: Variant;
}

const NormalProductNutrition = ({
  productVariant,
}: NormalProductNutritionProps) => {
  const nutritionalValue = useMemo(
    () => calculateNutritionalValues(productVariant),
    [productVariant],
  );

  const { calorie, fat, carb, protein } = nutritionalValue;

  return (
    <div className="tw-flex tw-gap-2 md:tw-gap-2.5 xl:tw-gap-8 tw-flex-1 tw-items-end">
      <ProductNutrient name="kCal" value={calorie ?? 0} />
      <ProductNutrient name="Fats" value={fat ?? 0} unit="g" />
      <ProductNutrient name="Carbs" value={carb ?? 0} unit="g" />
      <ProductNutrient name="Protein" value={protein ?? 0} unit="g" />
    </div>
  );
};

export default NormalProductNutrition;
